<template>
  <SlotBanner
    class="webinar-banner"
    start="2025-02-18T00:00:00.000Z"
    finish="2025-02-26T17:00:00.000Z"
  >
    <div class="webinar-banner__inner">
      <img
        src="@/assets/images/banner/picture.svg"
        class="webinar--banner__img"
        alt="Webinar banner image"
        width="132"
        height="73"
      />
      <img
        src="@/assets/images/banner/live_mobile.svg"
        class="webinar-banner__live-mobile"
      />
      <div class="webinar-banner__container">
        <div class="webinar-banner__text-content">
          <div class="webinar-banner__title">
            <div class="webinar-banner__title-part">Webinar</div>
            <img
              src="@/assets/images/banner/live.svg"
              class="webinar-banner__live"
            />
            <div class="webinar-banner__title-part">February 26</div>
          </div>
          <div class="webinar-banner__text-wrapper">
            <div class="webinar-banner__sub-title">
              Better SOC with Interactive Sandbox
              <span class="webinar-banner__description">
                Practical Use Cases
              </span>
            </div>
          </div>
        </div>
      </div>
      <a
        href="https://anyrun.webinargeek.com/better-soc-with-interactive-malware-sandbox-practical-use-cases?cst=banner"
        class="webinar-banner__link"
        target="_blank"
        >Register now</a
      >
    </div>
  </SlotBanner>
</template>

<script>
import { defineComponent } from 'vue';

import SlotBanner from './SlotBanner.vue';

export default defineComponent({
  name: 'WebinarBanner',
  components: { SlotBanner },
});
</script>

<style lang="scss" scoped>
.webinar-banner {
  font-family: 'Montserrat', sans-serif;

  background-color: #022044;
}

.webinar-banner__inner {
  display: flex;
  align-items: center;
  gap: 50px;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 1314px;
  height: inherit;
  margin: 0 auto;
  padding: 0 16px;
}

.webinar-banner__container {
  display: flex;
  gap: 40px;
  align-items: center;
}

.webinar-banner__text-content {
  display: flex;
  justify-content: center;
  gap: 30px;
}

.webinar-banner__title {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
  height: inherit;

  font-size: 35px;
  font-weight: 900;
  line-height: 40px;
  color: #fff;
}

.webinar-banner__title-part {
  position: relative;

  font-family: 'Montserrat', sans-serif;
  white-space: nowrap;
}
.webinar-banner__live {
  width: 82px;
  height: 34px;
}

.webinar-banner__text-wrapper {
  font-family: 'Montserrat', sans-serif;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: inherit;
  font-weight: 900;
  font-size: 18px;
  line-height: 24px;
}

.webinar-banner__sub-title {
  color: #fff;
}

.webinar-banner__description {
  color: #02c0fc;
}

.webinar-banner__link {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 168px;
  height: 42px;
  padding: 4px 26px;

  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #fff;
  text-decoration: none;
  white-space: nowrap;

  background-color: #02c0fc;
  border-radius: 4px;
  appearance: none;
  transition: background-color 0.15s ease;

  &:hover {
    text-decoration: none;
    background-color: #42d2ff;
  }
}

.webinar-banner__live-mobile {
  display: none;
}

@media screen and (max-width: 1440px) {
  .webinar-banner__inner {
    margin-left: 0;
    margin-right: auto;
    padding-left: 13px;
  }
}

@media screen and (min-width: 1100px) and (max-width: 1280px) {
  .webinar-banner__inner {
    margin-left: auto;
    margin-right: 0;
    padding-left: 0;
    position: relative;
    gap: 0;
    justify-content: space-between;
  }

  .webinar-banner__title {
    font-size: 25px;
    line-height: 40px;
  }
  .webinar--banner__img {
    position: relative;
    margin-left: -20px;
  }
  .webinar-banner__sub-title {
    width: 376px;
  }
}

@media screen and (min-width: 660px) and (max-width: 1100px) {
  .webinar-banner__inner {
    margin: 0 auto;
    padding: 0 20px;
    gap: 30px;
    justify-content: space-between;
  }

  .webinar-banner__text-content {
    flex-direction: column;
    gap: 0;
  }

  .webinar-banner__title {
    font-size: 19px;
    line-height: 20px;
  }

  .webinar--banner__img {
    position: static;
    margin-left: -30px;
    width: 108px;
    height: 54px;
    left: 13px;
  }

  .webinar-banner__live {
    height: 20px;
    width: auto;
  }

  .webinar-banner__text-wrapper {
    font-size: 13px;
    font-weight: 700;
    line-height: 120%;
  }

  .webinar-banner__sub-title {
    width: 283px;
  }
  .webinar-banner__container {
    gap: 50px;
  }
}
@media screen and (min-width: 320px) and (max-width: 659px) {
  .webinar--banner__img {
    display: none;
  }

  .webinar-banner__live {
    display: none;
  }

  .webinar-banner__inner {
    justify-content: center;
    gap: 15px;
    padding: 0;
  }

  .webinar-banner__text-content {
    display: block;
    height: 100%;
    width: min-content;
  }

  .webinar-banner__title {
    gap: 0px;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 10px;
  }

  .webinar-banner__text-wrapper {
    line-height: 120%;
    font-weight: 700;
    font-size: 10px;
  }

  .webinar-banner__title-part:nth-of-type(1) {
    border-right: 1px solid rgba(255, 255, 255, 0.5);
    padding-right: 5px;
  }

  .webinar-banner__title-part:nth-of-type(2) {
    padding-left: 5px;
  }

  .webinar-banner__link {
    padding: 9px 20px;
    width: fit-content;
  }

  .webinar-banner__live-mobile {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 66px;
  }
}
</style>
